import { useContext } from 'react';

import { AuthContext } from 'store/context';

export const useAuth = function () {
  const {
    AuthState: { token, initURL, authUser },
  } = useContext(AuthContext);
  const isAuthenticated = !!token;

  return {
    initURL,
    user: authUser,
    token,
    isAuthenticated,
  };
};
